import { Injectable, Inject } from 'ng-metadata/core';
import { ConfigurationUtil } from '../../../nddUtils/configurationUtil.service';
import { getGoogWithProxy } from '../../../appConfig/appConfigForward';
import { getBackendSystem, getQuickLinkEnabled } from '../../../appConfig/appConfigForward';
import { MappingTablesCache } from '../../../mappingTablesCache/mappingTablesCache.service';
import { getVid } from '../../../appConfig/appConfigForward';
import { QuickLink } from "../../quickLink/quickLink.service";

const get = require('lodash/get');

@Injectable()
export class FullViewLinksService {

    private linksDefinitions: any;
    private vid = getVid();


    constructor(@Inject('$http') private $http,
        private configurationUtil: ConfigurationUtil,
        @Inject('$translate') private $translate: ng.translate.ITranslateService,
        private quickLinkService: QuickLink,
        private mappingTablesCache: MappingTablesCache) {
        let fullViewConfiguration = configurationUtil.getFullViewConfiguration();
        let linksConf;
        if (fullViewConfiguration) {
            linksConf = fullViewConfiguration.resultlinks;
        }
        if (linksConf) {
            this.linksDefinitions = linksConf[0].links.split(',');
        }
    }
    set showNoLinksErrorlabel(value: boolean) {
        this.quickLinkService.showNoLinksErrorlabel = value;
    }

    get showNoLinksErrorlabel() {
        return this.quickLinkService.showNoLinksErrorlabel;
    }

    public hasLinks(item) {

        if (this.linksDefinitions) {
            if (this.hasGoogleLinks(item)) return true;

            if (this.hasSourceRecordLink(item)) {
                return true;
            }

            if (item.delivery) {
                let links = item.delivery.link;
                if (links) {
                    for (let i = 0; i < this.linksDefinitions.length; i++) {
                        if (this.linksDefinitions[i].length > 0) {
                            for (let j = 0; j < links.length; j++) {
                                if (links[j].linkType.endsWith(this.linksDefinitions[i])) return true;
                            }
                        }
                    }
                }
            }

            if (this.quickLinkService.isQuickLinksAvailable(item) || this.quickLinkService.isUnpaywallLinksAvailable([item])) {
                return true;
            }
        }

        return false;
    }

    public hasSourceRecordLink(item) {

        if (this.linksDefinitions) {
            if (this.linksDefinitions.indexOf('sourcerecord') !== -1 && this.isLocal(item)) {
                return true;
            }
        }

        return false;
    }

    public isLocal(item) {
        if (item.context === 'L') {
            return true;
        }

        if (item.context === 'U' && item.pnx.control.sourceid && item.pnx.control.sourceid.indexOf('alma') !== -1) {
            return true;
        }
        return false;
    }

    public getSourceRecordLinkName() {
        return 'sourcerecord';
    }

    public hasGoogleLinks(item) {

        if (this.linksDefinitions) {
            if ((this.linksDefinitions.indexOf('gbsabout') !== -1 ||
                this.linksDefinitions.indexOf('gbsfull') !== -1 ||
                this.linksDefinitions.indexOf('gbsaboutnofull') !== -1) &&
                item.pnx && item.pnx.addata && (item.pnx.addata.isbn || item.pnx.addata.oclcid)) {
                return true;
            }
        }

        return false;
    }

    public getPnxLinks(item, googleLinks?) {
        let linksToReturn = [];
        let links = get(item, 'delivery.link', false);
        if (!links) {
            return linksToReturn;
        }
        for (const linkDefinition of this.linksDefinitions) {
            if (linkDefinition.length == 0) {
                continue;
            }
            let addedLinks = [];
            let linksToCheck = links;
            if ((linkDefinition === 'gbsabout' || linkDefinition === 'gbsfull' || linkDefinition === 'gbsaboutnofull') && googleLinks) {
                linksToCheck = googleLinks;
            }
            if (linksToCheck) {
                for (const link of linksToCheck) {
                    if (!link.linkType.endsWith(linkDefinition)) {
                        continue;
                    }
                    let linkUrl = link.linkURL;
                    let displayLabel = link.displayLabel;
                    let ar = linkUrl.split(" $$L");
                    // URM-209859: link URL may contain " $$L" followed by link label
                    if (ar.length == 2) {
                        linkUrl = ar[0];
                        displayLabel = ar[1];
                    }
                    // The same URL may appear multiple times with different labels,
                    // but all URL+label combinations must be unique.
                    let key = linkUrl + ' ' +  displayLabel;
                    if (addedLinks.indexOf(key) !== -1) {
                        continue;
                    }
                    addedLinks.push(key);
                    if (displayLabel === linkDefinition) {
                        displayLabel = this.$translate.instant('fulldisplay.' + displayLabel);
                    }
                    link.linkURL = linkUrl;
                    link.displayLabel = displayLabel;
                    linksToReturn.push(link);
                }
            }
        }
        return linksToReturn;
    }

    public getGoogleLinks(books) {
        let googleLinks = [];
        let keys = Object.keys(books);

        if (keys) {
            for (let i = 0; i < keys.length; i++) {

                if (books[keys[i]]) {

                    let book = books[keys[i]];
                    let viewabilityState = book.preview;

                    if (book.info_url) {
                        googleLinks.push({ linkType: 'gbsabout', linkURL: book.info_url, displayLabel: '$$Egbsabout' });
                    }

                    if ((viewabilityState === 'partial' || viewabilityState === 'full') && book.preview_url) {
                        googleLinks.push({ linkType: 'gbsfull', linkURL: book.preview_url, displayLabel: '$$Egbsfull' });
                    }

                    if ((viewabilityState === 'partial' || viewabilityState === 'full') && book.preview_url) {
                        googleLinks.push({ linkType: 'gbsaboutnofull', linkURL: book.preview_url, displayLabel: '$$Egbsaboutnofull' });
                    } else if (viewabilityState === 'noview' && book.info_url) {
                        googleLinks.push({ linkType: 'gbsaboutnofull', linkURL: book.info_url, displayLabel: '$$Egbsaboutnofull' });
                    }

                    if (googleLinks.length > 0) {
                        return googleLinks;
                    }
                }
            }
        }

        return googleLinks;
    }

    public handleGoogleLinks(item) {

        let googleUrl = getGoogWithProxy();

        let isbn = false;
        let oclc = false;

        if (item.pnx.addata.isbn) {
            googleUrl += 'ISBN:' + item.pnx.addata.isbn[0];
            isbn = true;
        }

        if (item.pnx.addata.oclcid) {
            if (isbn) {
                googleUrl += ',';
            }

            googleUrl += 'OCLC:' + item.pnx.addata.oclcid[0];
            oclc = true;
        }

        if (isbn || oclc) {
            googleUrl += '&jscmd=viewapi';
            return this.$http.jsonp(googleUrl);
        }
    }

    public hasMayAlsoBeFoundAtLinks(item) {
        if (item.delivery) {
            let links = get(item, 'delivery.mayAlsoBeFoundAt', false);
            if (links) {
                return true;
            }
        }
        return false;
    }

    public getMayAlsoBeFoundAtLinks(item) {
        let links = get(item, 'delivery.mayAlsoBeFoundAt', false);
        return links;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/links/serviceLinks.service.ts